import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { fadeIn } from "~/styles/animations";

const handleBreakpoints = ({ theme, xs, sm, md, lg, xl }) => {
    let styles = ``;

    if (xs) {
        styles += `
            @media (min-width: ${theme.breakpoints.mobilePortrait}) {
                width: ${typeof xs === "string" ? xs : `${xs * 100}%`};
            }
        `;
    }

    if (sm) {
        styles += `
            @media (min-width: ${theme.breakpoints.tabletPortrait}) {
                width: ${typeof sm === "string" ? sm : `${sm * 100}%`};
            }
        `;
    }

    if (md) {
        styles += `
            @media (min-width: ${theme.breakpoints.tabletLandscape}) {
                width: ${typeof md === "string" ? md : `${md * 100}%`};
            }
        `;
    }

    if (lg) {
        styles += `
            @media (min-width: ${theme.breakpoints.desktop}) {
                width: ${typeof lg === "string" ? lg : `${lg * 100}%`};
            }
        `;
    }

    if (xl) {
        styles += `
            @media (min-width: ${theme.breakpoints.largeDesktop}) {
                width: ${typeof xl === "string" ? xl : `${xl * 100}%`};
            }
        `;
    }

    return css`
        ${styles}
    `;
};

const getJustifyContentBreakpoints = ({
    theme,
    justifyContentWithBreakpoint,
    justifyBreakpoint,
}) => {
    switch (justifyBreakpoint) {
        case "xs":
            return css`
                @media (min-width: ${theme.breakpoints.mobilePortrait}) {
                    justify-content: ${
                        justifyContentWithBreakpoint
                            ? justifyContentWithBreakpoint
                            : "flex-start"
                    };
                }
            `;
        case "sm":
            return css`
                @media (min-width: ${theme.breakpoints.tabletPortrait}) {
                    justify-content: ${
                        justifyContentWithBreakpoint
                            ? justifyContentWithBreakpoint
                            : "flex-start"
                    };
                }
            `;
        case "md":
            return css`
                @media (min-width: ${theme.breakpoints.tabletLandscape}) {
                    justify-content: ${
                        justifyContentWithBreakpoint
                            ? justifyContentWithBreakpoint
                            : "flex-start"
                    };
                }
            `;
        case "lg":
            return css`
                @media (min-width: ${theme.breakpoints.desktop}) {
                    justify-content: ${
                        justifyContentWithBreakpoint
                            ? justifyContentWithBreakpoint
                            : "flex-start"
                    };
                }
            `;
        case "xl":
            return css`
                @media (min-width: ${theme.breakpoints.largeDesktop}) {
                    justify-content: ${
                        justifyContentWithBreakpoint
                            ? justifyContentWithBreakpoint
                            : "flex-start"
                    };
                }
            `;
        default:
            return css``;
    }
};

const getPadding = ({
    doubleVerticalSpacing,
    halfGutter,
    noGutter,
    noVerticalSpacing,
    theme,
}) => {
    const gutter = halfGutter ? theme.layout.halfGutter : theme.layout.gutter;

    return css`
        padding-left: ${noGutter ? `0` : `calc(${gutter} / 2)`};
        padding-right: ${noGutter ? `0` : `calc(${gutter} / 2)`};
        padding-top: ${
            noVerticalSpacing
                ? `0`
                : doubleVerticalSpacing
                  ? theme.layout.doubleGutter
                  : gutter
        };
        padding-bottom: 0;
    `;
};

const Col = styled.div`
    ${getPadding};
    display: ${({ flex }) => (flex ? `flex` : `block`)};
    flex: 0 1 auto;
    width: 100%;
    animation: ${({ animated }) =>
        animated
            ? css`
                  ${fadeIn} 0.5s ease
              `
            : `none`};
    flex-direction: ${({ flexColumn }) => (flexColumn ? "column" : "row")};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : `flex-start`};

    ${getJustifyContentBreakpoints};
    ${handleBreakpoints};
`;

export default Col;
